module.exports = __webpack_public_path__ + "img/subtask.d48fc37e.svg";